import Sinistres from '@amo/core/assets/images/AMO_Icons/Sinistres.svg';
import { Question } from '@amo/core/components/containers';
import { AddSinistre } from '@amo/core/components/group-form';
import _ from 'lodash';
import moment from 'moment';
import { FieldArray } from 'redux-form';
import {getTranslation} from "../../../utils/index.js";

export const SinistresAutoMoto = (props) => {
    const { nextQuestion, data, antecedentsSur3ans, title, canDelete, changeValue } = props;
    // Mise a jour de declaration : l'anteriorite des sinistres se calcule par rapport a la date d'effet de l'affaire nouvelle
    const dateAffaireNouvelle = _.get(data, 'DemandeTarif[Police][DateAffaireNouvelleContrat]');
    const dateReference = _.get(data, 'DemandeTarif[Police][MotifAvenant]') === '8' && moment(dateAffaireNouvelle, 'DD/MM/YYYY', true).isValid()
        ? dateAffaireNouvelle
        : undefined;

    const isNotValid = () => {
        const liste = _.get(data, `DemandeTarif[Antecedents][ListeSinistres]`);

        // "Oui" sélectionné mais aucun sinistre saisi : le détail est obligatoire
        if (_.isEmpty(liste)) {
            return true;
        }

        let notValid = false;
        _.forEach(liste, function (k, v) {
            if (
                !_.get(data, `DemandeTarif[Antecedents][ListeSinistres][${v}][NatureSinistre]`) ||
                !_.get(data, `DemandeTarif[Antecedents][ListeSinistres][${v}][VehiculeSinistre]`) ||
                !moment(
                    _.get(data, `DemandeTarif[Antecedents][ListeSinistres][${v}][DateSinistre]`),
                    'DD/MM/YYYY',
                    true,
                ).isValid()
            ) {
                notValid = true;
            }

            if (
                _.get(data, `DemandeTarif[Antecedents][ListeSinistres][${v}][NatureSinistre]`) &&
                _.includes(
                    ['CIR', 'STA'],
                    _.get(data, `DemandeTarif[Antecedents][ListeSinistres][${v}][NatureSinistre]`),
                ) &&
                !_.get(data, `DemandeTarif[Antecedents][ListeSinistres][${v}][Responsabilite]`) &&
                !_.get(data, `DemandeTarif[Antecedents][ListeSinistres][${v}][TypeSinistre]`)
            ) {
                notValid = true;
            }
        });

        return notValid;
    };
    const onClickNext = () => {
        changeValue('DemandeTarif[Antecedents][ListeSinistres]', [])
        nextQuestion(0)
    };


    return (
        <Question
            icon={Sinistres}
            title={title ? title : getTranslation('antecedents.accidentModule.title')}
            subtitle={getTranslation('antecedents.subtitle', {count: antecedentsSur3ans ? 3 : 2})}
            position={'bottom'}
        >
            <div className={'row justify-content-center mt-2'}>
                <div className={'col-12 my-2'}>
                    <FieldArray
                        name={'DemandeTarif[Antecedents][ListeSinistres]'}
                        component={AddSinistre}
                        sinistres={_.get(data, 'DemandeTarif[Antecedents][ListeSinistres]')}
                        antecedentsSur3ans={antecedentsSur3ans}
                        dateReference={dateReference}
                    />
                </div>
                {canDelete &&
                    <div className={'col-12 my-2'}>
                        <button
                            className={`btn btn-primary btn-arrow mt-4`}
                            onClick={() => onClickNext()}
                        >
                            {getTranslation('antecedents.accidentModule.noAccident')}
                        </button>
                    </div>
                }
            </div>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${isNotValid() && 'disabled'}`}
                onClick={() => nextQuestion()}
            >
                {getTranslation('continue')}
            </button>
        </Question>
    );
};
